import { VulnBadgeColors } from '../Badge/Badge';
import { VulnSeverity } from '../../../../shared/issuesV2';

/**
 * Maps the vuln severity to the BadgeColors.
 *
 * @param {VulnSeverity} severity - A given vuln severity
 * @returns {BadgeColors} - the badge color to be returned
 */
export const severityToBadgeColor = (severity: string): VulnBadgeColors => {
  switch (severity) {
    case VulnSeverity.Critical:
      return VulnBadgeColors.Critical;
    case VulnSeverity.High:
      return VulnBadgeColors.High;
    case VulnSeverity.Medium:
      return VulnBadgeColors.Medium;
    case VulnSeverity.Low:
      return VulnBadgeColors.Low;
    case VulnSeverity.Unknown:
    default:
      return VulnBadgeColors.Unknown;
  }
};
